<div  class="card">
    <div class="text-center">
        <i class="fa fa-user fa-4x"></i>
    </div>
    <h4 class="card-header">Create New Activity Type</h4>
    <div class="card-body">
        <div class="alert alert-danger text-center" *ngIf="errorEncountered">
            Error Creating Activity Type
        </div>

        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="form-group input-group-lg">
                <input placeHolder="Activity Type Name" type="text" formControlName="name" class="form-control" [ngClass]="{ 'is-invalid': f.name.errors && f.name.touched }" />
                <div *ngIf="f.name.errors && f.name.touched" class="invalid-feedback">
                    <div *ngIf="f.name.errors.required">Name is required</div>
                </div>
            </div>

            <div class="form-group row input-group-lg">
                <div class="col-sm-6 offset-sm-3">
                <button [disabled]="loading" class="btn btn-primary btn-lg btn-block">
                    <span *ngIf="loading" class="spinner-border spinner-border-sm me-1"></span>
                    Submit
                </button>
            </div>
            </div>
        </form>
    </div>


</div>
